import { render, staticRenderFns } from "./StatDoctorPechat.vue?vue&type=template&id=3f8cc371"
import script from "./StatDoctorPechat.vue?vue&type=script&lang=js"
export * from "./StatDoctorPechat.vue?vue&type=script&lang=js"
import style0 from "./StatDoctorPechat.vue?vue&type=style&index=0&id=3f8cc371&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports